import {createStore} from 'vuex';

// Modules
import tab from './modules/tab';
import language from './modules/language';

const store = createStore({
  modules: {
    tab,
    language,
  },
});

export default store;
